// extracted by mini-css-extract-plugin
module.exports = {"grid":"Result_grid__SRVdf","birdsConatiner":"Result_birdsConatiner__20WA9"};